import { useState } from 'react';
import { Paperclip, ChevronDown, ChevronUp } from 'lucide-react';
import AttachmentSection from './AttachmentSection';

/**
 * Collapsible photo/file expander.
 * - Shows a "Photos (n)" toggle button with paperclip icon
 * - Lazy-mounts <AttachmentSection> only when expanded — zero API calls until clicked
 *
 * Props:
 *   parentType, parentId — passed to AttachmentSection
 *   initialCount         — count to show in the badge before expansion (from bulk-counts)
 *   defaultOpen          — open on first render (default false)
 */
export default function AttachmentExpander({ parentType, parentId, initialCount = 0, defaultOpen = false }) {
    const [open, setOpen] = useState(defaultOpen);
    const [count, setCount] = useState(initialCount);

    return (
        <div className="mt-3" data-testid={`attach-expander-${parentType}-${parentId}`}>
            <button
                type="button"
                onClick={() => setOpen(o => !o)}
                className="inline-flex items-center gap-1.5 text-xs font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 transition-colors"
                data-testid={`attach-toggle-${parentType}-${parentId}`}
            >
                <Paperclip className="w-3.5 h-3.5" />
                <span>Photos {count > 0 ? `(${count})` : ''}</span>
                {open ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
            </button>

            {open && (
                <div className="mt-2">
                    <AttachmentSection
                        parentType={parentType}
                        parentId={parentId}
                        enabled={true}
                        compact={true}
                        onCountChange={setCount}
                    />
                </div>
            )}
        </div>
    );
}
